import { Flex, Typography } from "antd";
import { ReactComponent as HandshakeIcon } from "../../../images/handshake.svg";
import styles from "./AgentInfoBlock.module.css";

interface AgentInfoBlockProps {
  text: string;
  label: string;
  icon?: React.ReactNode;
}

export const AgentInfoBlock = ({ text, label, icon }: AgentInfoBlockProps) => {
  return (
    <Flex gap="small" align="flex-start" className={styles.container}>
      <div className="square icon-3xl bg-basic-200">{icon ?? <HandshakeIcon />}</div>
      <Flex vertical gap="4px" className="flex-grow">
        <Typography.Text type="secondary">{label}</Typography.Text>
        <Typography.Text>{text}</Typography.Text>
      </Flex>
    </Flex>
  );
};
